import axios from 'api/axios'
import { Broadcast, BroadcastStatus } from 'types'

export interface GetAllBroadcastsParams {
	page: number
	size: number
	client?: string
	query?: string
	status?: BroadcastStatus
}

export interface GetAllBroadcastsResponse {
	records: Array<Broadcast>
	currentPage: number
	totalCount: number
	totalPages: number
}

const getAllBroadcasts = async (
	params: GetAllBroadcastsParams
): Promise<GetAllBroadcastsResponse> => {
	const { data } = await axios.get<{ response: GetAllBroadcastsResponse }>(
		'v1/broadcast/management',
		{
			params: {
				...params,
				status: (params.status as string) === 'ALL' ? undefined : params.status,
			},
		}
	)

	return data.response
}

export default getAllBroadcasts
